export const updateObjectState = (key, value, state) => {
    let newState = {...state}
    for(let k in newState) {
        if (k === key) {
            newState[`${k}`] = value
        }
    }
    return newState
}